<template>
    <div class="cancel-upload-wrapper">
        <button v-if="isUploading" :disabled="false" class="widget-btn cancel-upload-btn" @click.prevent="cancelUpload">Cancel</button>
        <button v-else class="widget-btn cancel-upload-btn" :disabled="true">Cancel</button>
    </div>
</template>

<script>
    export default {
        props: ["isUploading", "bus"],
        methods: {
            cancelUpload: function (e) {
                this.bus.emit("cancelUpload");
            }
        }
    }
</script>